import { useEffect, useState } from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import Button from "../../../utils/components/Button";
import getLocation from "../../../utils/helpers/getLocation";
import { Translate } from "react-localize-redux";

const GPSMap = ({
  lat,
  lng,
  disabled,
  required,
  hidden,
  handleUpdate,
  type,
  userLocation,
}) => {
  const [latitude, setLatitude] = useState(lat);
  const [longitude, setLongitude] = useState(lng);
  const containerStyle = {
    width: type === "small_map" ? "50%" : "100%",
    height: type === "small_map" ? "250px" : "500px",
  };

  const [gettingLocation, setGettingLocation] = useState(false);

  useEffect(() => {
    if (lat && lng) {
      setLatitude(lat);
      setLongitude(lng);
    }
  }, [lat, lng]);

  function onMapClick(e) {
    if (disabled) return;
    setLatitude(e.latLng.lat());
    setLongitude(e.latLng.lng());

    if (handleUpdate) {
      handleUpdate(e.latLng.lat(), e.latLng.lng());
    }
  }

  const handleGetLocation = () => {
    setGettingLocation(true);
    if (userLocation) {
      setLatitude(userLocation?.lat);
      setLongitude(userLocation?.lng);
      if (handleUpdate) handleUpdate(userLocation?.lat, userLocation?.lng);

      setGettingLocation(false);
    } else {
      getLocation((location) => {
        setLatitude(location?.lat);
        setLongitude(location?.lng);
        if (handleUpdate) handleUpdate(location?.lat, location?.lng);

        setGettingLocation(false);
      });
    }
  };

  return (
    <div className="w-100">
      <div className="row">
        <div className="col-12 col-lg-10">
          <GoogleMap
            onClick={(e) => {
              onMapClick(e);
            }}
            mapContainerStyle={containerStyle}
            center={{ lat: latitude, lng: longitude }}
            zoom={15}
          >
            <Marker position={{ lat: latitude, lng: longitude }} />
          </GoogleMap>
          <Button
            className="btn fs-6 mt-2"
            onClick={handleGetLocation}
            disabled={gettingLocation}
          >
            <Translate
              id={gettingLocation ? "loading" : "forms.get_location"}
            />
          </Button>
        </div>
      </div>
    </div>
  );
};
export default GPSMap;
